import React from 'react';
import { Circle, CheckCircle2, Clock, XCircle, Pause } from 'lucide-react';

export type TicketStatus = 'open' | 'pending' | 'resolved' | 'closed';

interface StatusBadgeProps {
  status: TicketStatus;
  size?: 'sm' | 'md' | 'lg';
}

export function StatusBadge({ status, size = 'md' }: StatusBadgeProps) {
  const config: Record<TicketStatus, { label: string; icon: typeof Circle; className: string; iconClassName: string }> = {
    open: {
      label: 'Open',
      icon: Circle,
      className: 'bg-emerald-50 text-emerald-700 ring-1 ring-inset ring-emerald-600/10',
      iconClassName: 'text-emerald-500'
    },
    pending: {
      label: 'Pending',
      icon: Pause,
      className: 'bg-amber-50 text-amber-700 ring-1 ring-inset ring-amber-600/10',
      iconClassName: 'text-amber-500'
    },
    resolved: {
      label: 'Resolved',
      icon: CheckCircle2,
      className: 'bg-gray-50 text-gray-600 ring-1 ring-inset ring-gray-500/10',
      iconClassName: 'text-gray-400'
    },
    closed: {
      label: 'Closed',
      icon: XCircle,
      className: 'bg-gray-50 text-gray-500 ring-1 ring-inset ring-gray-500/10',
      iconClassName: 'text-gray-400'
    }
  };

  const statusConfig = config[status] || config.open;
  const { label, icon: Icon, className, iconClassName } = statusConfig;

  const sizeClasses = {
    sm: 'px-1.5 py-0.5 text-[10px]',
    md: 'px-2 py-0.5 text-xs',
    lg: 'px-2.5 py-1 text-sm'
  };

  const iconSizes = {
    sm: 10,
    md: 12,
    lg: 14
  };

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-md font-medium ${className} ${sizeClasses[size]}`}
    >
      <Icon size={iconSizes[size]} className={iconClassName} />
      {label}
    </span>
  );
}
